import React from 'react';
import { BillingProfileCardsLoader } from './common/billing-profile-cards-loader';
import { SkeletonLoader, SkeletonLoaderWrapper } from '@css-xp/skeleton-loader';
import { Box } from '@atlaskit/primitives';

export const SelectBillingProfilePageLoader = () => {
  return (
    <div data-testid="select-billing-profile-loader">
      <Box paddingBlockStart="space.250">
        <SkeletonLoaderWrapper>
          <SkeletonLoader width="30%" />
        </SkeletonLoaderWrapper>
        <BillingProfileCardsLoader />
      </Box>
    </div>
  );
};
